import React, { useEffect } from "react";
import { IAddress, ITkLocationGroupProps } from "../../../type/componentsType/TkLoactionGroup";
import { Box } from "@mui/material";
import TkPrefecturesSelect from "../../atoms/TkPrefecturesSelect";
import TkLabelText from "../../atoms/TkLabelText";
import "./_style.scss";

/**
 * 住所入力フォーム部品
 * 「都道府県」、「市区町村」、「その他」のグループフォーム
 * @param {ITkLocationGroupProps} props - コンポーネントのプロパティ
 * @param {Object} props.valueObject - 住所情報を含むオブジェクト
 * @param {string} props.valueObject.prefectures - 都道府県
 * @param {string} props.valueObject.city - 市区町村
 * @param {string} props.valueObject.address - その他の住所
 * @param {Function} props.onChange - 住所情報が変更された時に呼ばれるコールバック関数
 * @returns TkLocationGroup 住所入力フォーム部品
 */
export const TkLocationGroup: React.FC<ITkLocationGroupProps> = (props) => {
  const {
    valueObject,
    setDefaultValue,
    onChange,
    error,
    errorMessage,
    disabled,
    disabledAddress,
    disabledCity,
    disabledPrefectures,
    ...rest
  } = props;
  const [prefecture, setPrefecture] = React.useState<string>(
    valueObject?.prefectures || ""
  );
  const [city, setCity] = React.useState<string>(valueObject?.city || "");
  const [address, setAddress] = React.useState<string>(
    valueObject?.address || ""
  );
  const [errorMsg, setErrorMsg] = React.useState<{
    prefectures?: string;
    city?: string;
    address?: string;
  }>({
    prefectures: "",
    city: "",
    address: "",
  });

  useEffect(() => {
    try {
      if (error) {
        setErrorMsg(
          (errorMessage && JSON.parse(errorMessage)) || {
            prefectures: "",
            city: "",
            address: "",
          }
        );
      } else {
        setErrorMsg({
          prefectures: "",
          city: "",
          address: "",
        });
      }
    } catch (e) {}
  }, [error, errorMessage]);

  useEffect(() => {
    !!valueObject && changeValues(valueObject);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueObject]);

  useEffect(() => {
    if(
      !!setDefaultValue
      && !!setDefaultValue?.prefectures
      && !!setDefaultValue?.city
      && !!setDefaultValue?.address
    ) {
      changeValues(setDefaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setDefaultValue]);

  function changeValues(value?: IAddress) {
    setPrefecture(value?.prefectures || "");
    setCity(value?.city || "");
    setAddress(value?.address || "");
    setTimeout(() => {
      onChange && onChange({ target: { value } });
    }, 0);
  }

  const handleChange = (
    event: any,
    runFunc: React.Dispatch<React.SetStateAction<string>>
  ) => {
    runFunc(event.target.value);

    const returnRes = {
      value: {
        prefectures:
          runFunc === setPrefecture ? event.target.value : prefecture,
        city: runFunc === setCity ? event.target.value : city,
        address: runFunc === setAddress ? event.target.value : address,
      },
    };

    onChange && onChange({ target: { ...returnRes } });
  };

  return (
    <Box className="tkLocationGroup">
      <Box className="secUp">
        <TkPrefecturesSelect
          {...rest}
          onChange={(e) => handleChange(e, setPrefecture)}
          wantToSetValue={prefecture}
          error={!!errorMsg.prefectures}
          disabled={disabled || disabledPrefectures}
        />

        <TkLabelText
          {...rest}
          onChange={(e) => handleChange(e, setCity)}
          className="text"
          placeholder="市区町村"
          error={!!errorMsg.city}
          helperText={errorMsg.city}
          wantToSetValue={city}
          disabled={disabled || disabledCity}
          InputProps={{
            inputProps: { "data-testid": "addressCity" },
          }}
        ></TkLabelText>
      </Box>

      <Box>
        <TkLabelText
          {...rest}
          onChange={(e) => handleChange(e, setAddress)}
          fullWidth
          placeholder="番地以下"
          error={!!errorMsg.address}
          helperText={errorMsg.address}
          wantToSetValue={address}
          disabled={disabled}
          InputProps={{
            inputProps: { "data-testid": "addressOthers" },
          }}
        ></TkLabelText>
      </Box>
    </Box>
  );
};

export default TkLocationGroup;
